import type { TFunction } from 'i18next';

import yup from '../../../helpers/yupInstance';

export function getUserInfoFormValidation(t: TFunction) {
  return yup.object({
    firstname: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.firstnameRequired')),
    lastname: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.lastnameRequired')),
    description: yup
      .string()
      .max(4096, t('formikValidation.maxLength').replace('{0}', '4096')),
  });
}
